<template>
    <div>
        <el-row :gutter="8">
          <el-col :span="8" v-for="(item,index) in voices" :key="index" class="voiceColumn">
            <el-card :body-style="{ padding: '0px' }"
            @mouseleave.native="mouseLeave(index)"
            @mouseover.native="mouseOver(index)"
            id="card">
              <div slot="header">
                <i class="el-icon-microphone" :style='item.color'></i>
                {{item.name}}
              </div>
              <div>
                <p v-for="(subItem,subIndex) in item.displayContent" :key="subIndex">{{subItem}}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      voices: [{
        id: '1',
        name: 'ひろさん様',
        voice: ['全文検索ソフトでは最高峰の出来！',
          '仕事で、大量の文書から過去の記述を検索する必要があり、これまで様々な全文検索ソフトを試してきました。どれも一長一短あって、なかなか満足のいくものに出会えなかったのですが、とうとう巡り会いました！このソフトは、私の考えうる要望を全て満たしています。もう、手放せません。加えて、ユーザーへの対応も丁寧！'
        ],
        subTitle: ['全文検索ソフトでは最高峰の出来！'],
        displayContent: [],
        color: 'color:Violet'
      }, {
        id: '2',
        name: 'a-natsuki様',
        voice: ['知る限り今Windows8で数少ない「店売りのネットワークドライブ上のファイルを対象に全文検索可能」なソフトです。',
          '何故かwindowsサーチは７→8になって検索対象から「Windows8以外でたてられたネットワークドライブ」を外してしまい、よく売っているようなLinaxベースのネットワークドライブの中が検索できなくなっていたので、このソフトがなかったらWindows7のOSを買うことになっていたでしょう。もし出来るならばインデックスの作製がやっぱり時間がかかるので、時間指定でインデックス更新ができれば最高です。'
        ],
        subTitle: ['知る限り今Windows8で数少ない「店売りのネットワークドライブ上のファイルを対象に全文検索可能」なソフトです'],
        displayContent: [],
        color: 'color:Violet'
      }, {
        id: '3',
        name: '電子ブックナビ様',
        voice: ['自炊したPDFにOCRをかけて情報の検索に使われている方も多いと思います。探している単語で検索してくれるので大変便利ですが、ファイルを一旦開かないと検索できないため、どのファイルに載っているか分からない時や全部のファイルを検索したい時には困ってしまいます。以前はGoogle desktopがサポートされていたのでそれを使っていましたが、提供されなくなって困っていらっしゃる方も多いと思います。',
          'そんな時に役立つツール「全文検索くん（Search++）を紹介します。',
          '「全文検索くん（Search++）」インデックス型全文検索ツールです。ファイルが保管されてるフォルダを指定するとファイルの内容（OCRテキスト付PDFの場合はテキスト）をインデックス化してくれますので、複数のファイルから検索語を見つけて表示してくれます。',
          'ドライブを割り当てると、ネットワーク上のフォルダも対象になりますので、LANDISKに入れたファイルも検索してくれます。'
        ],
        subTitle: ['Google desktopがなくなって、困った時、このソフトを見つけて、良かった。'],
        displayContent: [],
        color: 'color:Violet'
      }, {
        id: '4',
        name: 'はな様',
        voice: ['翻訳するにあたって翻訳会社から大量の資料が送られてくることがあります。',
          '今回の案件はかなり大規模な医療機器で附属機器もたくさんありそれぞれに添付文書があります。機器の前のバージョンの添付文書が参考資料として送られてきて、わからない訳語があるたびに旧添付文書で該当箇所（とそれに近いところ）を読んで言葉をさがしたりあたりをつけます。資料がたくさんあると探すのも大変、、、、。',
          'Windowsの検索機能もありますが、PDFの中身についてはできません。 そんなとき「全文検索君(Search++)」を使っています。初期設定で検索場所を指定でき、キーワード検索をかけるとそのキーワードの記載がある文書がウィンドウの左側に全てリストアップされ、掲載場所の抜粋が右側に併記されます。',
          '検索も早いのでかなり重宝しています。 翻訳以外にも「○○についての資料があった気がするけどどの文書がわかんー」というときにも使えて便利です。'
        ],
        subTitle: ['翻訳会社から大量の資料が送られてくることがあります、そんなとき「全文検索君(Search++)」を使っています。かなり重宝しています。'],
        displayContent: [],
        color: 'color:Blue'
      }, {
        id: '5',
        name: 'Jinzai_3様',
        voice: ['ファイル名検索ソフトは多数ありますが、そのほとんどは「内容検索」が出来ません。本ソフトは多数のファイル形式（拡張子）に対応した「ファイル内文字検索」が出来るので、パソコン内に保管している自分が作成したファイルやダウンロードした各種情報の検索に大変重宝しています。',
          '私は紙の情報はスキャナーで読み込みパソコン内に多数保管しています。このOCRソフトはあるメーカーのDocuWorksを使用しています（多数の企業等で使用しています）。このたび全文検索くんVer.2.8.2からこのDocuWorks文書（拡張子.xdw）も検索可能になり、必要な情報が簡単に読み出せるため大変助かっています。皆様も是非どうぞ。'
        ],
        subTitle: ['紙の情報はスキャナーで読み込みパソコン内に多数保管しています、全文検索くんは必要な情報を簡単に読み出せるため大変助かっています。'],
        displayContent: [],
        color: 'color:Blue'
      }, {
        id: '6',
        name: 'osumi-jimusyo様',
        voice: ['縦書きや横書きの大量のPDF資料の中から目的のファイルを素早く探すことができて、とても便利です。',
          'ビアクロバットの検索は一回一回ものすごく時間がかかる上、その確認もたいへんでしたが、このソフトはクリック一つで検索結果内容を素早く確認できたり、そのファイルを開いたり、とても使いやすくできていて大満足です。これまでいくつも検索ソフトを試してみましたが最も良いソフトです。',
          'サポートもとても親切・丁寧で嬉しい限りです。'
        ],
        subTitle: ['縦書きや横書きの大量のPDF資料の中から目的のファイルを素早く探すことができて、とても便利です。'],
        displayContent: [],
        color: 'color:Blue'
      }, {
        id: '7',
        name: 'てつ様',
        voice: ['仕事柄、メーカーの部品カタログや取扱説明書をPDFでたくさん使わなければならないのですが、これらのファイル名はたいていメーカ独自の通し番号などで後からどれがどのファイルだったかわかりにくいものです。 かといってファイル名を変えてしまうと頻繁に改訂があるため自分の持っているものが最新かどうか分かりづらくなってしまいます。 adobe readerやPDF Xchangeにはフォルダ内からの検索機能がありますが、フォルダ指定が面倒なのと毎回検索のため非常に時間がかかっていました。 他の検索ソフトもgrep系は毎回検索で、データベース化を謳っているものも一度検索したキーワードについてのみでした。 このソフトは本当に一瞬で検索ができるので助かります。 また、サポートもしっかりしていて信頼できます。 一ヶ月じっくり試用してから購入しました。'
        ],
        subTitle: ['部品カタログや取扱説明書を一瞬で検索ができるので助かります、一ヶ月じっくり試用してから購入しました。'],
        displayContent: [],
        color: 'color:Black'
      }, {
        id: '8',
        name: 'haruka1971様',
        voice: ['私は翻訳の仕事をしておりますが、英語、日本語のキーワードでファイル検索は日常作業によくあることです、ほかのツールと比べる、内容検索力、キーワードハイライト機能などが優れています。作業にかかる時間が大幅に短縮できました。ほんとうに助かりました。'
        ],
        subTitle: ['翻訳の仕事で、ほかのツールと比べる、内容検索力、キーワードハイライト機能などが優れています'],
        displayContent: [],
        color: 'color:Black'
      }, {
        id: '9',
        name: 'ti2013様',
        voice: ['Windows Desktop searchはXP以降、検索能力がダメになりました。 Win7 の検索は賛否分かれているような感じですが、私のPCでは全然ダメです。 Search++は、やっと出てきた有り難いソフトです。'
        ],
        subTitle: ['Search++は、やっと出てきた有り難いソフトです'],
        displayContent: [],
        color: 'color:Black'
      }
      ],
      cardheight: '180px'
    }
  },
  created () {
    this.voices.forEach(item => {
      item.displayContent = item.subTitle
    })
  },

  methods: {
    mouseOver (index) {
      console.log('mouseover ' + index)
      this.voices[index].displayContent = this.voices[index].voice
    },
    mouseLeave (index) {
      console.log('mouseleave' + index)
      this.voices[index].displayContent = this.voices[index].subTitle
    }
  }
}
</script>

<style scoped>
.voiceColumn {
    margin-bottom: 20px;
}

#card {
     /* width:180px; */
    height:180px;
    /* background:gold; */
    /* transition:height 2s; */
    /* -webkit-transition:height 2s;  */
    padding: 10px;
}

#card:hover
{
    height:auto;
}
</style>
